<template>
  <div class="orderManageCon">
    <Card>
         <div class="search-div flexC">
            <div class="search-div-item flexC">
              <div class="labelText">{{$t("productManage.addModel.baseType")}}</div>
              <Input class="input-div" :placeholder='$t("inputPlaceholder")' clearable v-model="searchObj.baseType" ></Input>
           </div>

            <!-- <div class="search-div-item flexC">
              <div class="labelText">{{$t("orderManage.titleName.OrderId")}}</div>
              <Input class="input-div" :placeholder='$t("inputPlaceholder")' clearable v-model="searchObj.id" ></Input>
           </div>

            <div class="search-div-item flexC">
              <div class="labelText">{{$t("orderManage.titleName.Order")}}</div>
              <Input class="input-div" :placeholder='$t("inputPlaceholder")' clearable v-model="searchObj.orderName" ></Input>
           </div> -->

            <div class="search-div-item">
               <Button type="info" @click="searchItem"  icon="ios-search" style="margin-top:5px;height:44px;line-height:44px;width:96px;border-radius: 10px;">{{$t('search')}}</Button>
            </div>
       </div>
        <div class="top">
            <Button type="success" class="addButton1" :disabled="buttonList.addDisabled" @click="addData(1)" style="margin-right:8px;">{{$t("orderManage.addButton")}}</Button>
            <Button type="primary" class="addButton1" :disabled="buttonList.editDisabled" @click="addData(2)" style="margin-right:8px;">{{$t("orderManage.editButton")}}</Button>

        </div>
         <Table  :columns="titleName" :data="tableList.tableData" @on-sort-change="sortCustom" ref="selection" @on-selection-change="selectChange"  :loading='loading'></Table>

          <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :page-size-opts="[10,20,30,50]" placement="top" class="pages"/>
          <!-- 编辑 / 添加  模态框组件 -->
           <ModelBox :showModel.sync="addBox.showModel" :fn="addBox.callbackFn" :type="type" :editFormData="addBox.editFormData"></ModelBox>

          <!-- 详情 -->
          <detailModelBox :showModel.sync="detailBox.showModel" :fn="detailBox.callbackFn"  :editFormData="detailBox.editFormData"></detailModelBox>

          <!-- 删除弹框组件 -->
          <DeleteDialog ref="deleteChild" @ievent = "ievent"  :title='$t("orderManage.deletModel.changeTitle")' :cont='$t("orderManage.deletModel.changeCont")'></DeleteDialog>
    </Card>
  </div>
</template>
<script>
import common from '@/common/common.js';
import {debounce} from '@/libs/tools.js';
// import ModelBox from './component/addModel';
import ModelBox from './component/addModel-recycle.vue';
import detailModelBox from './component/detailModel.vue';
import moment from 'moment';
import DeleteDialog from '../common/deleteModel.vue'; // 引入删除弹框组件
import { mapState } from 'vuex'

    export default {
        name: "merchantAdmin",
        components: {
            ModelBox,
            DeleteDialog,
            detailModelBox
        },
        data(){
            return{
                selectChangeData: [],
                loading: true,
                paging: true,
                type:1,//弹框打开类型 1添加 2编辑
                tableList:{//表格组
                    hasSelectData:{},//已选中的行的数据
                    tableData: [],//表格数据
                    tableDataAll:[]
                },
                addBox:{//规格弹框组-新增
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                },
                detailBox:{//规格弹框组-详情
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                },
                buttonList:{//按钮组
                    addDisabled:false,//添加按钮是否禁用
                    editDisabled:true,//编辑按钮是否禁用
                    delDisabled:true,//删除按钮是否禁用
                },
                page:{//分页排序
                    total:0,//总条数
                    pageSize:10,//每页条数
                    current:1,//当前页
                    key:'orderDate',
                    order:'desc'
                },
                Pitem:"",
                searchObj:{
                    baseType:"",
                    // id:"",
                    // orderName:""
                },
               
            }
        },
        computed:{
            ...mapState(['local','selectId']),
             roleType(){
	        	 let res = '2'
	        	 if(this.$store.state.uInfo && this.$store.state.uInfo.roleType){
	        		 res = this.$store.state.uInfo.roleType
	        	 }
	        	 return res
	         },
             titleName(){
                 return [
                    {
                      type: "selection",
                      width: 60,
                      align: "center",
                      fixed: "left",
                    },
                    {
                        title: this.$t('orderManage.titleName.OrderId'),
                        key: 'id',
                        sortable: true,
                        minWidth: 120,
                        render:(h, params)=>{
                            let stext = params.row.id
                             return h('div',stext || '')
                        }
                    },
                    {
                        title: this.$t('orderManage.titleName.Order'),
                        key: 'orderName',
                        sortable: true,
                        minWidth: 180,
                        render:(h, params)=>{
                            let stext = params.row.orderId || params.row.orderName
                             return h('div',stext || '')
                        }
                    },
                    {
                        title: this.$t('orderManage.titleName.OrderDate'),
                        key: 'orderDate',
                        width: 110,
                        render:(h, params)=>{
                            let stext = moment(params.row.orderDate*1).format('YYYY-MM-DD')
                             return h('div',stext || '')
                        }
                    },
                    {
                        title: this.$t('productManage.addModel.baseType'),
                        key: 'baseType',
                        sortable: true,
                        width: 130
                    },
                    {
                        title: this.$t('orderManage.titleName.ProductId'),
                        key: 'orderProductId',
                        sortable: true,
                        width: 130
                    },
                    {
                        title:this.$t('orderManage.titleName.Type'),
                        key: 'orderProductType',
                        minWidth: 150
                    },
                    {
                        title:this.$t('orderManage.addModel.frequency'),
                        key: 'frequency',
                        minWidth: 180
                    },
                    {
                        title: this.$t('orderManage.titleName.ProductName'),
                        key: 'orderProductName',
                        minWidth: 180,
                        render:(h, params)=>{
                            let stext = params.row.orderProductName || ''
                            return h('div',{
                                attrs:{
                                    title:stext
                                }
                            },stext)
                        }
                    },
                    {
                        title: this.$t('orderManage.titleName.Qty'),
                        key: 'qty',
                        width: 100,
                        // sortable: true,
                    },

                    {
                        title: this.$t('orderManage.titleName.Remark'),
                        key: 'remark',
                        minWidth: 140,
                        render:(h, params)=>{
                            let stext = params.row.remark || ''
                            return h('div',{
                                attrs:{
                                    title:stext
                                }
                            },stext)
                        }
                    },
                   
                    {
					    title: this.$t('orderManage.titleName.Operation'),
					    minWidth:this.roleType ==1?220 :120,
                        key: "id",
                        // fixed:'right',
					    render: (h, params) => {
                            let that = this
                            return [h('div',
                                       { 
                                        style:{
                                            display: "flex",
                                            justifyContent:'center'
                                            }
                                        },[
                                            h('Button', {
					                            props: {
                                                    type: "primary",
                                                    size: 'small'
                                                },
                                                style:{
                                                    // display: params.row.is_share == 1&& params.row.pay_status == 2 ?'block':'none',
                                                    marginRight:"10px",
                                                    background: '#4ABAF0',
                                                    color: '#fff',
                                                    borderColor: '#4ABAF0',
                                                    borderRadius: '6px',
                                                },
					                            on: {
					                                click: () => { this.showDetail(params.row) }
					                            }
					                        },that.$t("orderManage.detail")),

                                            h('Button', {
					                            props: {
                                                    type: "primary",
                                                    size: 'small',
                                                    loading: params.row.$isLoading || false
                                                },
                                                attrs:{
                                                    disabled:params.row.whetherFillDevice && params.row.instanceStatus!= 2 
                                                },
                                                style:{
                                                    display: this.roleType == 1 ?'block':'none',
                                                    marginRight:"10px",
                                                    background: (!params.row.whetherFillDevice || (params.row.whetherFillDevice && (params.row.instanceStatus== 2)) )?'#2d8cf0':'#f7f7f7',
                                                    color: (!params.row.whetherFillDevice|| (params.row.whetherFillDevice && (params.row.instanceStatus==2)) )?'#fff':'#c5c8ce',
                                                    borderColor: (!params.row.whetherFillDevice|| (params.row.whetherFillDevice && (params.row.instanceStatus== 2)) )?'#2d8cf0':'#dcdee2',
                                                    borderRadius: '6px',
                                                },
					                            on: {
					                                click: () => {
                                                        console.log((params.row.whetherFillDevice && params.row.instanceStatus== 1) || (!params.row.whetherFillDevice && params.row.instanceStatus== 3))
                                                        if(!params.row.whetherFillDevice) {
                                                            this.realize(params.row) 
                                                        }
                                                        if(params.row.whetherFillDevice && (params.row.instanceStatus== 2)){
                                                            
                                                            this.instance(params.row) 
                                                        }
                                                    }
					                            }
					                        },(params.row.whetherFillDevice && (params.row.instanceStatus== 2 || params.row.instanceStatus== 3))?that.$t("orderManage.Instance"):that.$t("orderManage.Realize")),
                                            
            
                                            h('Button', {
					                            props: {
                                                    type: "error",
                                                    size: 'small'
                                                },
                                                attrs:{
                                                    disabled:params.row.whetherFillDevice
                                                },
                                                style:{
                                                    // display: params.row.is_share == 1&& params.row.pay_status == 2 ?'block':'none',
                                                    // background: '#E76D6A',
                                                    // color: '#fff',
                                                    // borderColor: '#E76D6A',
                                                    background: (!params.row.whetherFillDevice)?'#E76D6A':'#f7f7f7',
                                                    color: (!params.row.whetherFillDevice)?'#fff':'#c5c8ce',
                                                    borderColor: (!params.row.whetherFillDevice)?'#E76D6A':'#dcdee2',

                                                    borderRadius: '6px',
                                                },
					                            on: {
					                                click: () => { 
                                                        if(!params.row.whetherFillDevice){

                                                            this.todelData(params.row) 
                                                        }
                                                    }
					                            }
					                        },that.$t("orderManage.delete"))
                                         ]
                                    )]
					    }
					},
                ]
             } 
        },
        created() {
           
            this.getData();
        },
        watch: {
        
        },
        methods: {
            selectT(val){//选择日期
                // console.log(val)
                this.searchObj.loan_time = val
                this.searchObj.loan_time = val.join(',')
            },
            realize(item){//实现
                if(this.roleType != 1) return
                this.$set(item,'$isLoading', true);
                this.axios.post(this.config.urlArray.fillOrder, {id:item.id}).then((result)=>{
                    common.ajaxMsg(result.data,true,()=>{
                        this.getData();
                        setTimeout(() => {
                            this.$set(item,'$isLoading', false);
                        }, 1500);
                    },()=>{
                        this.$set(item,'$isLoading', false);
                    })
                }).catch((err)=>{
                     this.$set(item,'$isLoading', false);
                })
            },
            instance(item){//实例
                if(this.roleType != 1) return
                this.$set(item,'$isLoading', true);
                this.axios.post(this.config.urlArray.doInstance, {id:item.id}).then((result)=>{
                    common.ajaxMsg(result.data,true,()=>{
                        this.getData();
                        setTimeout(() => {
                            this.$set(item,'$isLoading', false);
                        }, 1500);
                    },()=>{
                        this.$set(item,'$isLoading', false);
                    })
                }).catch((err)=>{
                     this.$set(item,'$isLoading', false);
                })
            },
            todelData(item) {// 删除
                this.tableList.hasSelectData = item
                this.$refs.deleteChild.showit();
            },
            ievent() {// 删除
                this.axios.post(this.config.urlArray.orderDel, {id:this.tableList.hasSelectData.id}).then((result)=>{
                    
                    common.ajaxMsg(result.data,true,()=>{
                        this.$refs.deleteChild.recancel();
                        this.getData();
                    })
                }).catch((err)=>{
                    // common.msg('error','删除失败')
                })
            },
            searchItem(){ //搜索
                this.loading = true
                this.page.current = 1
                this.page.pageSize = 10
                this.getData()
            },
            getData() {//获取数据

                // console.log(start,end)
                let params= {
                        page: this.page.current,
                        limit: this.page.pageSize,
                        sortfield: this.page.key,
                        ascDesc: this.page.order,
                        dealerId:this.selectId
                    }

                Object.assign(params,this.searchObj)

                this.axios.post(this.config.urlArray.orderShow,params).then((result) => {
                    common.ajaxMsg(result.data,false)
                    let resData = result.data.data
                    //处理数组
                    if(resData){
                        this.tableList.tableDataAll  =  resData
                        if(!resData.meta){//分页不生效
                            // Object.keys(this.searchObj).forEach(key => {
                            //       if (this.searchObj[key] === '' || this.searchObj[key] === undefined || this.searchObj[key] === null) return this.tableList.tableDataAll 
	                        //       this.tableList.tableDataAll = this.tableList.tableDataAll.filter(p =>{
                            //         if(typeof p[key]=='number' || typeof p[key]=='boolean'){
                            //             return p[key] === this.searchObj[key]
                            //         }
                            //         return p[key] === null || p[key].includes(this.searchObj[key])
                            //       })
                            // })
                            this.paging = false
                            this.page.total = resData.length
                            this.getDataPage()
                        }else{
                            this.tableList.tableData = resData
                            this.page.total = resData.meta.count
                        }
                        
                        this.loading = false
                    }else{
                        this.tableList.tableData = []
                        this.page.total = 0
                        this.loading = false
                        return false
                    }
                }).catch((err) => {
                    // common.msg('error','获取失败',()=>{})
                });
            },
             getDataPage(){
                let start = (this.page.current-1)*this.page.pageSize
                let end = (this.page.current)*this.page.pageSize
                let key =  this.page.key
                let order = this.page.order

                this.tableList.tableDataAll.sort((a, b) => {
                  const valA = a[key]
                  const valB = b[key]
                
                  if (valA == null || valB == null) return 0 // 空值不排序
                
                  if (typeof valA === 'number' && typeof valB === 'number') {
                    return order === 'asc' ? valA - valB : valB - valA
                  } else {
                    return order === 'asc'
                      ? String(valA).localeCompare(String(valB))
                      : String(valB).localeCompare(String(valA))
                  }
                })

                this.page.total = this.tableList.tableDataAll.length
                this.tableList.tableData = this.tableList.tableDataAll.slice(start,end)

            },
            
            addData(type) {  //添加或编辑数据
                this.addBox.showModel = true
                this.type = type
                if(type == 2) {
                    this.addBox.editFormData = this.tableList.hasSelectData
                }
                this.addBox.callbackFn = () => {//回调处理
                    //重新载入
                    this.clearbtnStatus()
                    this.addBox.showModel = false;
                    this.getData();
                }
            },
            showDetail(row){
                this.detailBox.showModel = true
                this.detailBox.editFormData = row
                // console.log('row',row)
                this.detailBox.callbackFn = () => {//回调处理
                    //重新载入
                    this.clearbtnStatus()
                    this.detailBox.showModel = false;
                    // this.getData();
                }
            },
            selectChange(res) { //控制编辑和删除按钮的可用状态
                this.selectChangeData = res
                // if(res.length == 1 && this.roleType==1 && res[0].whetherFillDevice==false){
                if(res.length == 1){
                    this.buttonList.editDisabled = this.buttonList.delDisabled = false
                    this.tableList.hasSelectData = res[0]
                }else{
                    this.buttonList.editDisabled = this.buttonList.delDisabled = true
                    this.tableList.hasSelectData = {}
                }
            },
            sortCustom(data) {//自定义排序
                this.page.key = data.key
                this.page.order = data.order
                if(this.paging){
                    this.getData()          
                }else{
                    this.getDataPage()  
                }
            },
            changePage(nowpage) {//切换分页
                this.page.current = nowpage;
                if(this.paging){
                    this.getData()          
                }else{
                    this.getDataPage()  
                }
            },
            changeSize(nowSize) {//切换每页显示条数
                this.page.pageSize = nowSize
                this.page.current = 1
                if(this.paging){
                    this.getData()          
                }else{
                    this.getDataPage()  
                }
            },
            clearbtnStatus() { //删除后清空编辑数据 与按钮状态
                this.buttonList.delDisabled = true
                this.buttonList.editDisabled = true
                this.addBox.editFormData ={}
                this.tableList.hasSelectData = {}
            },
        }
    }
</script>
<style lang="less" scoped>

.top{

    margin: 30px auto
}
.pages{

    margin: 30px auto
}
.orderManageCon{

    margin: 42px 40px 8px;
    .addButton1{
       border-radius: 6px;
    }
}

.search-div{
     flex-wrap: wrap;
     background-color: #fff;
    
     background: #FFFFFF;
     margin: 20px 0px;
     border-radius: 14px;
     .search-div-item{
         margin-right: 20px;
         span{
             margin-right: 30px;
         }
     }
     /deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
         height:44px;
         line-height: 44px;
     }
     /deep/ .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
         height:44px;
         line-height: 44px;
     }
      /deep/ .ivu-select-single .ivu-select-selection{
        height: 44px;
        width: 200px;
     }
     /deep/  .ivu-input{
          height: 44px;
         line-height: 44px;
     }
     /deep/ .ivu-input-icon{
         height: 44px;
         line-height: 44px;
     }
     /deep/ .ivu-select-input{
         height: 44px;
         line-height: 44px;
     }
 }
 .labelText{
     line-height: 54px;
     height: 54px;
     flex-shrink: 0;
     margin-right: 10px;
 }

</style>

